import axios from "axios";

async function generateApiToken() {
  const tokenResponse = await axios.get(
    `${process.env.VUE_APP_API_GATEWAY}generateToken?key=${process.env.VUE_APP_API_KEY}`
  );
  return tokenResponse.data;
}

async function generateUniqueIdentifier(filename) {
  const tokenResponse = await axios.get(
    `${process.env.VUE_APP_API_GATEWAY}generateUniqueIdentifier?key=${process.env.VUE_APP_API_KEY}&filename=${filename}`
  );
  return tokenResponse.data;
}

async function generateZipIdentifier(name) {
  const tokenResponse = await axios.get(
    `${process.env.VUE_APP_API_GATEWAY}generateZipIdentifier?key=${process.env.VUE_APP_API_KEY}&name=${name}`
  );
  return tokenResponse.data;
}

export default {
  generateApiToken,
  generateUniqueIdentifier,
  generateZipIdentifier
};
